import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalLoginComponent } from './global-login.component';


import { SocialLoginModule } from '@abacritt/angularx-social-login';
import { DialogModule } from 'primeng/dialog';
import { SidebarModule } from 'primeng/sidebar';

import { GoogleSigninButtonModule,} from '@abacritt/angularx-social-login';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    GlobalLoginComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SocialLoginModule,
    DialogModule,
    SidebarModule,
    GoogleSigninButtonModule
  ],
  exports:[GlobalLoginComponent],
  schemas: []
})
export class GlobalLoginModule { }
